import { FormEvent, ReactNode } from 'react'
import Spreadsheet from '../../../utils/spreadsheet'

interface iInputFileProps{
  accept: string
  children: ReactNode
  onChange: (data:any[])=>void
  onFail: (reason: string)=>void
}

export default function Input_file({accept, children, onChange=()=>{}, onFail=()=>{}}:iInputFileProps) {

  const handleOnChange = async(e: FormEvent<HTMLInputElement>)=>{

      let data;
    
      try {

          const file = e.currentTarget.files ? e.currentTarget.files[0] : null

          if(file){
            data = await Spreadsheet.readSpreadSheet(file)
            onChange(data)
          }
      } catch (error) {
          onFail(error as string)
      }
  }
  
  return (
    <div className='w-full relative'>
        <input 
          onChange={handleOnChange} 
          className='w-full h-full opacity-0 absolute top-0 left-0 z-10' 
          type='file'
          accept={accept}
        />
        {children}
    </div>
  )
}
